import { TwitterOutlined, FacebookOutlined, LinkedinOutlined } from "@ant-design/icons"
import { Dropdown } from "antd"
import { useTranslation } from "translations"
import { EN, VI } from "translations/languages"

function FooterPrivate() {
  const { t } = useTranslation()

  return (
    <div className="container border-t-[1px] border-solid border-[#e9e8eb]">
      <div className="py-4 flex items-center gap-4 justify-between flex-col">
        <div className="flex items-center gap-2">
          <p className="font-extrabold text-xl">{t('Alo Wallet')}</p>
          <p className="text-xs text-[#858792]">{t('Copyright © 2025. All rights reserved')}</p>
        </div>

        <DropDownLanguage />

        {/* Social Media Links */}
        <div className="flex items-center gap-2">
          <p className="text-base text-[#858792]">{t('Join the community')}:</p>
          <TwitterOutlined className="text-xl cursor-pointer" />
          <FacebookOutlined className="text-xl cursor-pointer" />
          <LinkedinOutlined className="text-xl cursor-pointer" />
        </div>
      </div>
    </div>
  )
}

export default FooterPrivate

export const DropDownLanguage = () => {
  const { currentLanguage, setLanguage, t } = useTranslation()

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'en',
            label: 'EN',
            onClick: () => setLanguage(EN),
          },
          {
            key: 'vn',
            label: 'VN',
            onClick: () => setLanguage(VI),
          },
        ],
      }}
      placement="top"
    >
      <div className="flex items-center gap-2 cursor-pointer">
        <p className="text-base text-[#858792]">{t('Language')}:</p>
        <p className="font-extrabold uppercase text-xl">{currentLanguage.code}</p>
      </div>
    </Dropdown>
  )
}
